export default __webpack_public_path__ + "static/case04-2dc8cc1a43c3d85469cf02dd3ad48aa4.webp";